module.exports = __webpack_public_path__ + "img/reports--avatar.2a28dd7b.svg";